export default __webpack_public_path__ + "static/media/eg.54ce7cb9.svg";